<template>
    <div class="card-body" >                    
        <div class="row" v-if="descarga.status == 0">
            <div class="col-12">
                <h3>Si cierra esta ventana no podrá descargar los envios.</h3>
            </div>
            <div class="col-12" style="height: 250px">
                <LoaderComponent/>
            </div>
        </div>
        <div class="row" v-if="descarga.status == 1">
            <div class="col-12 text-center">
                <h2>Los envios se han cargado correctamente</h2>
                <Button :href="descarga.url" target="blank_">DESCARGAR ENVIOS</Button>
            </div>
        </div>
        <div class="row" v-if="descarga.status == 2">
            <div class="col-12 text-center">
                <h3>A ocurrido un error.</h3>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            descarga: Object
        },
        data() {
            return {
                interval: null
            }
        },
        created() {
            this.interval = setInterval(() => {
                this.getDescarga();
            }, 5000);
        },
        methods: {
            getDescarga() {
                const params = {
                    filters : {
                        descarga_id: this.descarga.id,
                    },
                    descarga_id: this.descarga.id,
                };
                this.$store.dispatch(this.config.getVuexAlias('back.descargas.get'), params).then(res => {
                    this.descarga = res.data.data;

                    if(this.descarga.status > 0) {
                        clearInterval(this.interval);
                    }
                });
            },
            close() {
                this.$emit('close');
            }
        }
    }
</script>